import React from 'react';
import Localize from 'react-intl-universal';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { formatPrice } from '@common/Util';
import { getCurrency } from '@pages/EventDetails/Util';

const StyledPriceContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '3px'
}));
const StyledPrice = styled(Typography)(() => ({
  display: 'inline',

  paddingLeft: '2px'
}));

const OrderSummaryItem = ({
  no = null,
  label = '',
  itemName = '',
  itemValue = null,
  bookedParticipants = []
}) => {
  return (
    <>
      <Grid item xs={1} sx={{ alignContent: 'center' }}>
        {no && <Typography display='inline'>{no}</Typography>}
      </Grid>
      <Grid item xs={7} sx={{ overflowWrap: 'anywhere', textAlign: 'left' }}>
        <Box display='inline' sx={{ fontSize: '14px' }}>
          {label && (
            <Typography sx={{ color: 'text.secondary', lineHeight: '0.9', fontSize: 13 }}>
              {Localize.get(`${label}`)}
            </Typography>
          )}
          {itemName}
        </Box>
      </Grid>
      <Grid item xs={4} sx={{ flexShrink: 0, textAlign: 'end', alignContent: 'end' }}>
        {itemValue && (
          <StyledPriceContainer>
            {formatPrice(itemValue)}
            <StyledPrice>{getCurrency(bookedParticipants)}</StyledPrice>
          </StyledPriceContainer>
        )}
      </Grid>
    </>
  );
};
export default OrderSummaryItem;
